import { ExampleBadgeComponent } from "@webapp/examples/example-badge/example-badge";
import { NgModule } from "@angular/core";
import { ExamplesComponent } from "@webapp/examples/examples.component";
import { UiModule } from "@webapp/ui/ui.module";
import { ExampleButtonsComponent } from "@webapp/examples/example-buttons/example-buttons.component";
import { ExampleIconsComponent } from "@webapp/examples/example-icons/example-icons.component";
import { ExampleWhiteboardComponent } from "@webapp/examples/example-whiteboards/example-whiteboard/example-whiteboard.component";
import { ExampleWhiteboardsComponent } from "@webapp/examples/example-whiteboards/example-whiteboards.component";
import { CommonModule } from "@angular/common";
import { ExampleDrawerComponent } from "@webapp/examples/example-drawer/example-drawer.component";
import { TestDrawerComponent } from "@webapp/examples/example-drawer/test-drawer-component/test-drawer.component";
import { ExampleModalComponent } from "@webapp/examples/example-modals/example-modal.component";
import { TestModalComponent } from "@webapp/examples/example-modals/test-modal/test-modal.component";
import { ExampleDividerComponent } from "@webapp/examples/example-divider/example-divider.component";
import { ExamplePopoverComponent } from "@webapp/examples/example-popover/example-popover.component";
import { ExampleSpinComponent } from "@webapp/examples/example-spin/example-spin.component";
import { ExampleMenuComponent } from "@webapp/examples/example-menu/example-menu.component";
import { ExamplePermissionsComponent } from "@webapp/examples/example-permissions/example-permissions.component";
import { ExamplesRoutingModule } from "@webapp/examples/examples-routing.module";
import { ExampleSelectComponent } from "@webapp/examples/example-select/example-select.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ExampleGridComponent } from "@webapp/examples/example-grid/example-grid.component";
import { NzSliderModule } from "ng-zorro-antd/slider";
import { ExampleFormComponent } from "@webapp/examples/example-form/example-form.component";
import { ExampleColorsComponent } from "@webapp/examples/example-colors/example-colors.component";
import { ExampleSkeletonComponent } from "@webapp/examples/example-skeleton/example-skeleton.component";
import { ExampleToggleComponent } from "@webapp/examples/example-toggle/example-toggle.component";
import { ExampleCheckboxComponent } from "@webapp/examples/example-checkbox/example-checkbox.component";
import { SharedModule } from "@webapp/shared/shared.module";
import { ExampleAvatarsComponent } from "@webapp/examples/example-avatars/example-avatars.component";
import { ExampleInputComponent } from "@webapp/examples/example-input/example-input.component";
import { ExampleRadioButtonsComponent } from "@webapp/examples/example-radio-buttons/example-radio-buttons.component";
import { ExampleAlertsComponent } from "@webapp/examples/example-alerts/example-alerts.component";
import { ExampleNotificationsComponent } from "@webapp/examples/example-notifications/example-notifications.component";
import { ExampleMentionsComponent } from "@webapp/examples/example-mentions/example-mentions.component";
import { ExampleCardComponent } from "@webapp/examples/example-card/example-card.component";
import { ExampleMessagesComponent } from "@webapp/examples/example-messages/example-messages.component";
import { ExampleTabComponent } from "@webapp/examples/example-tab/example-tab.component";
import { ExampleTagComponent } from "@webapp/examples/example-tag/example-tag.component";
import { ExampleCollapseComponent } from "@webapp/examples/example-collapse/example-collapse.component";
import { ExampleDropdownComponent } from "@webapp/examples/example-dropdown/example-dropdown.component";
import { ExampleTooltipComponent } from "@webapp/examples/example-tooltip/example-tooltip.component";
import { ExampleEmptyComponent } from "@webapp/examples/example-empty/example-empty.component";
import { ExampleListComponent } from "@webapp/examples/example-list/example-list.component";

@NgModule({
  declarations: [
    ExamplesComponent,
    ExampleAvatarsComponent,
    ExampleWhiteboardComponent,
    ExampleWhiteboardsComponent,
    ExampleIconsComponent,
    ExampleMessagesComponent,
    ExampleDrawerComponent,
    TestDrawerComponent,
    ExampleListComponent,
    ExampleButtonsComponent,
    ExampleBadgeComponent,
    ExampleAlertsComponent,
    ExampleModalComponent,
    ExampleToggleComponent,
    ExampleNotificationsComponent,
    TestModalComponent,
    ExampleSkeletonComponent,
    ExamplePopoverComponent,
    ExampleDividerComponent,
    ExampleInputComponent,
    ExampleCollapseComponent,
    ExampleSpinComponent,
    ExampleCardComponent,
    ExampleMenuComponent,
    ExampleTooltipComponent,
    ExamplePermissionsComponent,
    ExampleGridComponent,
    ExampleSelectComponent,
    ExampleCheckboxComponent,
    ExampleFormComponent,
    ExampleEmptyComponent,
    ExampleColorsComponent,
    ExampleRadioButtonsComponent,
    ExampleMentionsComponent,
    ExampleTabComponent,
    ExampleTagComponent,
    ExampleDropdownComponent,
  ],
  imports: [CommonModule, ExamplesRoutingModule, UiModule, FormsModule, NzSliderModule, SharedModule, ReactiveFormsModule],
})
export class ExamplesModule {}
